import ProductDetailPage from '../components/products/ProductDetailPage';
import { getProductPageConfig } from '../data/products/productsRegistry';

const PaperCupSleeves = () => <ProductDetailPage {...getProductPageConfig('paperCupSleeves')} />;

export default PaperCupSleeves;
